<template>
    <div :class="[{'alert-success': isOpen, 'alert-danger': !isOpen}, 'big-alert']" :style="{fontSize: fontSize}" role="alert">
        <strong :title="iconOnly ? alertText : ''">
            <i class="fa fa-exclamation-circle" />
        </strong>
        {{ iconOnly ? "" : alertText }}
    </div>
</template>

<script>
export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        fontSize: {
            type: String,
            default: "18px",
            required: false,
        },
        iconOnly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        alertText: function() {
            if (this.isOpen) {
                return 'Open'
            } else {
                return 'Closed'
            }
        }
    },
}
</script>

<style scoped>
.big-alert {
    border-radius: 4px;
    padding: 5px;
    display: inline-block;
    white-space: nowrap;
}
</style>
